const IS_DEV_MODE = process.env.NODE_ENV !== 'production';

export function useReduxDevTools() {
    return IS_DEV_MODE && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

// turn off sanitation if necessary
export function getDevCompose() {
    return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}
